export default __webpack_public_path__ + "3f83bf86c400bb97f89ba72524699060.png";